export const LABELS = {
  unitNumber: 'Unit Number',
  licensePlate: 'License Plate',
  vin: 'VIN',
  make: 'Make',
  model: 'Model',
  year: 'Year',
  assignedUser: 'Assigned User',
  status: 'Status'
};

export default LABELS;


